import apiClient from '@/services/axios'

export async function del(venueTaskId) {
  var response = await apiClient.delete('/VenueTasks/' + venueTaskId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to delete venue task.')
}